import axios from "axios";
import { apiCreditWiinUrl } from '../../constants/config';

export default {
  state: {
    nylasToken: [],
    },
  getters: {
    nylasToken: (state) => {
      return state.nylasToken;
    },
  },
  actions: {
    getUserEmails({ commit, state }, { id }) {
        state.nylasToken = [];
        return axios
        .get(apiCreditWiinUrl+'/nylas/nylastoken?user_id='+id, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        })
        .then(response => {
           
            response.data.forEach(element => {
                state.nylasToken.push(element);
            });
            if (state.nylasToken.length > 0) {
                localStorage.setItem('TokenForNylas',state.nylasToken[0].nylas_token);
            }
        }).catch(e => {});
    },

    NylasSendMessage({commit, state},{ body, subject, reply_to_message_id, to, cc, bcc,id_file=null }){

        let toFormat = [];

        for (var i in to) {
            toFormat.push({
                name: 'William Signes',
                email: to[i]
            })
        }
        let ccFormat = [];
        for (var j in cc) {
            ccFormat.push({
                name: '',
                email: cc[j]
            })
        }
        let bccFormat = [];
        for (var k in bcc) {
            bccFormat.push({
                name: '',
                email: bcc[k]
            })
        }

        return axios.post('https://api.nylas.com/send', {
            body: body,
            subject: subject,
            to: toFormat,
            cc: ccFormat,
            bcc: bccFormat,
            file_ids: null,
            tracking:{
                opens:true
            }
        }, {

            headers: {
                'Authorization': 'Bearer dtfmFrVcguCZFMQT0oPuzJ2jwSbQsw',
                // 'Authorization': 'Bearer ' + localStorage.getItem('TokenForEmails'),
                'Content-Type': 'application/json',
            }
        }).then((response) => {
        }).catch(e => {
            //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        })
    }
  }
};
